module.exports = __webpack_public_path__ + "static/media/icon-edit.85c27289.svg";